import React from 'react'

class CustomFilter extends React.Component {
    constructor(props) {
        super(props);
    }

    customFilterChange = (event) => {
        const { value } = event.target;
        let { selectedColumn, editMode } = this.props.filterParams;
        if (value != 'default') {
            let {min, max} = this.props;
            selectedColumn = value;
            editMode = true;
        }
        this.props.onFilterChange({ selectedColumn, editMode })
    }

    getCustomFilter = (min, max) => {
        let filterText;
        if (min == '' && max == '') filterText = `All`;
        else if (min != '' && max != '') filterText = `bt ${min} ${max}`;
        else if (min != '') filterText = `gt ${min}`
        else if (max != '') filterText = `lt ${max}`
        return filterText
    }
    
    onfilterParamChange = type => event => {
        let value = event.target.value;
        if(!isNaN(value))
            this.props.onFilterChange({[type] : value});
    }

    render() {
        const { editMode, min, max, selectedColumn } = this.props.filterParams;
        const textStyle = {
            marginRight: '1%',
            marginLeft: '1%',
            width: '30%'
        };
        return (
            <div className="form-group col-xs-12 col-sm-6 col-md-3">
                {!editMode ?
                    <div><label style={{ color: 'white' }} for="sel1">{'Filter Column'} :</label>
                        <select value={this.props.selectedColumn} onChange={this.customFilterChange} className="form-control" style={{ background: '#404040', color: "white" }} id="sel1">
                            <option value='default'> Select Column </option>
                            <option value='BuyInUSD'> Buy In </option>
                            <option value='PrizePoolUSD'> Prize Pool </option>
                            <option value='Overlay'> Overlay</option>
                            <option value='PredictedOverlay'> Predicted Overlay </option>
                        </select></div> :
                    <div>
                        <label style={{ color: 'white' }} for="sel1">{'Filter ' + selectedColumn} :</label>
                        <div className='row' style={{ margin: '2%' }}>
                             <input
                                style={textStyle}
                                type="text"
                                className="form-control col-xs-4 col-sm-4 col-md-4"
                                id="usr"
                                onChange={this.onfilterParamChange('min')}
                                value={min}
                            />
                            <input
                                style={textStyle}
                                type="text"
                                className="form-control col-xs-4 col-sm-4 col-md-4"
                                id="usr"
                                onChange={this.onfilterParamChange('max')}
                                value={max}
                            />
                            <button
                                style={{ margin: "20%" }}
                                type="button"
                                onClick={() => this.props.onFilterChange({ 
                                    editMode: false,
                                    min : 0,
                                    max : 0,
                                    errorText : ''
                                })}
                                className="btn col-xs-4 col-sm-4 col-md-4"
                                style={{ background: '#404040' }}
                            >
                                Esc X
                            </button>
                        </div>
                        <span style={{color : 'red'}}>{this.props.filterParams.errorText}</span>
                    </div>
                }
            </div>
        )
    }
}

export default CustomFilter




/** WEBPACK FOOTER **
 ** ./src/components/TournamentWatch/CustomFilter.js
 **/